var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('AppGlobalHeader'),_c('router-view'),_c('portal-target',{attrs:{"name":"slds-modal"}}),_c('portal-target',{attrs:{"name":"menu"}}),_c('portal-target',{attrs:{"name":"tooltip","multiple":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }